<template>
    <v-card-actions class="post-control">
        <v-layout row wrap>
            <v-flex xs6>
                <div
                    id="like_post_btn"
                    :data-qe-id="'post_like_div_' + activity.id"
                    :class="['post-control__action-btn', isAdminPagePostControl ? 'hidden' : '', canLike ? '' : 'disable_div']"
                    @click="handleLike()">
                    <img v-if="this.activity.userHasLiked" src="../../../assets/thumbs-up.png"/>
                    <img v-if="!this.activity.userHasLiked" src="../../../assets/thumbs-down.png"/>
                    <span :class="['post-control__label_Likes', postControlTextColor(communityCommonConstant.post.LIKE)]">
                        {{communityCommonConstant.post.LIKE}}
                    </span>
                    <span :data-qe-id="'post_likeCount_' + activity.id" :class="['post-control__tag', postControlCountColor(communityCommonConstant.post.LIKES)]">
                        {{activity.likeCount}}
                    </span>
                </div>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
                <div
                    id="comment_post_btn"
                    :data-qe-id="'post_comment_div_' + activity.id"
                    class="post-control__action-btn"
                    @click="handleComment()">
                    <v-icon
                        v-if="activity.commentCount === 0"
                        :color="postControlIconColor(communityCommonConstant.post.COMMENTS)"
                        class="post-control__comment-icon"
                        size="18">far fa-comment</v-icon>
                    <v-icon
                        v-if="activity.commentCount > 0"
                        :color="postControlIconColor(communityCommonConstant.post.COMMENTS)"
                        class="post-control__comment-icon"
                        size="18">fas fa-comment</v-icon>
                    <span :class="['post-control__label_Comments', postControlTextColor(communityCommonConstant.post.COMMENTS)]">
                {{ communityCommonConstant.post.COMMENTS}} 
            </span>
                    <span :data-qe-id="'post_commentCount_' + activity.id" :class="['post-control__tag', postControlCountColor(communityCommonConstant.post.COMMENTS)]">
                        {{isAdminPagePostControl ? activity.inappropriateChildren: activity.commentCount}}
            </span>
                </div>
            </v-flex>
            <v-flex class="first-like-comment" v-if="!isAdminPagePostControl && (!activity.likeCount || !activity.commentCount)">
                <span v-if="!activity.likeCount">
                {{communityCommonConstant.liked_Users.BE_THE_FIRST_TO_LIKE}} 
            </span>
                <span v-if="!activity.commentCount && activity.canComment" class="comments">
                {{communityCommonConstant.liked_Users.BE_THE_FIRST_TO_COMMENT}} 
            </span>
            </v-flex>
        </v-layout>
    </v-card-actions>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import {
        communityCommonConstant,
        likeStatement,
        commentStatement,
    } from "../communityCommon.constant";

    export default {
        name: "PostControl",
        data: () => ({
            communityCommonConstant,
            commentStatement,
        }),
        props: {
            handleLike: {
                type: Function,
                required: true,
            },
            canLike: {
                type: Boolean,
                required: true,
            },
            handleComment: {
                type: Function,
                required: true,
            },
            activity: {
                required: true,
            },
            isAdminPagePostControl: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            postControlIconColor(controlType) {
                return (this.activity.commentCount > 0 &&
                        controlType === communityCommonConstant.post.COMMENTS) ||
                    (this.activity.likeCount > 0 &&
                        controlType === communityCommonConstant.post.LIKES) ?
                    "ypo_cta" :
                    "ypo_blue_grey";
            },
            postControlTextColor(controlType) {
                return (this.activity.commentCount > 0 &&
                        controlType === communityCommonConstant.post.COMMENTS) ||
                    (this.activity.likeCount > 0 &&
                        controlType === communityCommonConstant.post.LIKES) ?
                    "ypo_cta_blue_color" :
                    "ypo_title_blue_grey_color";
            },
            postControlCountColor(controlType) {
                return (this.activity.commentCount > 0 &&
                        controlType === communityCommonConstant.post.COMMENTS) ||
                    (this.activity.likeCount > 0 &&
                        controlType === communityCommonConstant.post.LIKES) ?
                    "ypo_blue_color" :
                    "ypo_title_blue_grey_color";
            },

        },
        computed: {
            ...mapGetters({
                [storeGetters.usersCommunitiesList]: `chapter/${storeGetters.usersCommunitiesList}`,
            }),
            likesForThePost() {
                return likeStatement(this.activity);
            },
            commentForThePost() {
                return commentStatement(this.activity);
            },
            isMember() {
                return this.usersCommunitiesList && this.$route.params.communityId && this.usersCommunitiesList.some(u => u.communityId === this.$route.params.communityId);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';
    @import '../../../common/styles/_commonClasses.scss';

    .post-control {
        .disable_div {
            pointer-events: none;
            opacity: 0.5;
        }

        padding: 5px 0;

        &__action-btn {
            color: $ypo-gray;
            display: inline-block;
            cursor: pointer;

            &:hover {
                color: $ypo-blue;
            }
        }

        &__label_Likes {
            padding-left: 5px;
            position: relative;
            top: -2px;
            font-size: 12px;
            color: $ypo_blue;
            margin-right: 1px;

            &:hover {
                color: $ypo-cta;
            }
        }

        &__label_Comments {
            padding-left: 5px;
            position: relative;
            top: -2px;
            color: $ypo-dark-background-gray;
            letter-spacing: 0.36px;
            font-size: 12px;
            margin-right: 1px;

            &:hover {
                color: $ypo-cta;
            }
        }

        &__tag {
            color: $ypo-blue;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.42px;
            line-height: 16px;
            text-align: center;
            top: -2px;
            position: relative;
        }

        .first-like-comment {
            background-color: $ypo-extra-light-gray;
            font-size: 12px;
            padding: 15px 20px 15px 20px;
            font-weight: 600;
            margin-top: 10px;
            color: $ypo-dark-background-gray;
            line-height: normal;
            flex: auto;
            margin: 15px -20px -15px -20px;
            border-radius: 0 0 4px 4px;
            width: auto;
            max-width: inherit;
            letter-spacing: 0.36px;

            .comments {
                float: right;
            }
        }

        @media (max-width: 767px) {
            padding-top: 10px !important;

            .first-like-comment {
                padding: 15px 10px 15px 10px;
                font-size: 10px;
                margin: 15px -20px -10px -20px;
            }
        }
    }
</style>
